/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, date: NonNullable<unknown> }} Partner_Manage_Plan_PendingInputs */



/**
* | output |
* | --- |
* | "Downgrading to {plan} on {date}." |
*
* @param {Partner_Manage_Plan_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_plan_pending = /** @type {((inputs: Partner_Manage_Plan_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Plan_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Downgrade auf ${i?.plan} am ${i?.date}.`)
	return /** @type {LocalizedString} */ (`Downgrading to ${i?.plan} on ${i?.date}.`)
});